export default __webpack_public_path__ + "static/media/agpreport.577365df.png";